// To use the Component
import React, { Component, PropTypes } from 'react';
import GoogleAd from './GoogleAd';

// create a style object that is applied
// to the div wrapping the adSense code
// no styling required - just leave style object empty
const style = {
  marginTop: '15px',
  marginBottom: '20px'
};

class AdUnit extends Component {

  constructor(props) {
    super(props);
  }

  render(){
    if(this.props.hide){
      return(<h1>NO ADS</h1>)
    }
    else{
    return (
      <GoogleAd
        client="ca-pub-5678495791095919"
        slot="4985651773"
        format="auto"
        wrapperDivStyle={style}
      />
    );
    }
  }
}

AdUnit.PropTypes = {
  hide: PropTypes.bool
}

export default AdUnit;



// WEBPACK FOOTER //
// ./src/components/AdUnit.js